import * as React from 'react';
import { classNames, validatePropType } from 'uitk-react-utils';
import styles from './uitk-badge.css';
import { UitkBadgeNotificationThemes } from './types.esm.js';
var getClassNameList = classNames.bind(styles);
var UitkBadgeNotification = function (props) {
  var count = props.count,
    theme = props.theme,
    visible = props.visible,
    a11yText = props.a11yText,
    className = props.className,
    children = props.children;
  var baseCssClassName = 'uitk-badge';
  var notificationCssClassName = 'uitk-badge-notification';
  var hasCount = typeof count === 'string';
  var withIcon = false;
  React.Children.forEach(children, function (child) {
    var _a, _b;
    if ((_b = (_a = child.type) === null || _a === void 0 ? void 0 : _a.displayName) === null || _b === void 0 ? void 0 : _b.includes('UitkIcon')) {
      withIcon = true;
    }
  });
  var standardBadgeClassNames = getClassNameList(baseCssClassName, hasCount ? "".concat(notificationCssClassName, "-count") : "".concat(notificationCssClassName, "-dot"), withIcon ? "".concat(notificationCssClassName, "-with-icon") : "".concat(notificationCssClassName, "-with-text"), "".concat(notificationCssClassName, "-").concat(validatePropType(theme, UitkBadgeNotificationThemes) ? theme : UitkBadgeNotificationThemes.DEFAULT), className);
  return visible ? React.createElement("span", {
    className: getClassNameList("".concat(notificationCssClassName, "-wrapper"))
  }, withIcon ? React.createElement("span", {
    className: getClassNameList("".concat(notificationCssClassName, "-").concat(hasCount ? 'count-mask' : 'dot-mask'))
  }, children) : React.createElement(React.Fragment, null, children), React.createElement("span", {
    className: standardBadgeClassNames,
    "aria-hidden": !!a11yText
  }, hasCount && React.createElement("span", {
    className: getClassNameList("".concat(notificationCssClassName, "-numbers"))
  }, Number(count) > 99 ? '99+' : count), a11yText && React.createElement("span", {
    className: getClassNameList('is-visually-hidden')
  }, a11yText))) : React.createElement(React.Fragment, null, children);
};
UitkBadgeNotification.displayName = 'UitkBadgeNotification';
export { UitkBadgeNotification };